import { LightningElement } from "lwc";

class badge extends LightningElement {}

export default badge;
